import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=11f0c81c&scoped=true&"
import script from "./Register.js?vue&type=script&lang=js&"
export * from "./Register.js?vue&type=script&lang=js&"
import style0 from "./Register.vue?vue&type=style&index=0&id=11f0c81c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f0c81c",
  null
  
)

export default component.exports